import { render, staticRenderFns } from "./UserImg.vue?vue&type=template&id=00922fca&scoped=true&"
import script from "./UserImg.vue?vue&type=script&lang=js&"
export * from "./UserImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00922fca",
  null
  
)

export default component.exports